/* istanbul ignore file */
export * from './ProductPageHead';
